import { render, staticRenderFns } from "./ModalBuzzerSetting.vue?vue&type=template&id=f959386c&"
import script from "./ModalBuzzerSetting.vue?vue&type=script&lang=js&"
export * from "./ModalBuzzerSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports